import { getDiffArray, filterDiffFunction } from './chunk-WTGT4IDV.mjs';
import { selectLocationCourses, selectCurrentSettingsData } from './chunk-67X7HZEW.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/settingsDifferences/diffGuestCheckFactory.ts
var CustomizingReceiptsFieldLabels = /* @__PURE__ */ ((CustomizingReceiptsFieldLabels2) => {
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["append"] = 0] = "append";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["color"] = 1] = "color";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["fontSize"] = 2] = "fontSize";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["fontWeight"] = 3] = "fontWeight";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["justify"] = 4] = "justify";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["line"] = 5] = "line";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["order"] = 6] = "order";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["prepend"] = 7] = "prepend";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["status"] = 8] = "status";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["noLineBreak"] = 9] = "noLineBreak";
  return CustomizingReceiptsFieldLabels2;
})(CustomizingReceiptsFieldLabels || {});
var CustomizingReceiptsValueIdFieldLabels = /* @__PURE__ */ ((CustomizingReceiptsValueIdFieldLabels2) => {
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["updateStatus"] = 0] = "updateStatus";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["orderType"] = 1] = "orderType";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["orderName"] = 2] = "orderName";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["orderNumber"] = 3] = "orderNumber";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["table"] = 4] = "table";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["placedBy"] = 5] = "placedBy";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["server"] = 6] = "server";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["dateAndTime"] = 7] = "dateAndTime";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["stationName"] = 8] = "stationName";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["address"] = 9] = "address";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["guestCount"] = 10] = "guestCount";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["itemNameAndQuantity"] = 11] = "itemNameAndQuantity";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["seatNumber"] = 12] = "seatNumber";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["seatTags"] = 13] = "seatTags";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["modifiersInfo"] = 14] = "modifiersInfo";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["organizationName"] = 15] = "organizationName";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["locationName"] = 16] = "locationName";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["locationAddress"] = 17] = "locationAddress";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["checkName"] = 18] = "checkName";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["deliveryAddress"] = 19] = "deliveryAddress";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["time"] = 20] = "time";
  return CustomizingReceiptsValueIdFieldLabels2;
})(CustomizingReceiptsValueIdFieldLabels || {});
var SortTableLabels = /* @__PURE__ */ ((SortTableLabels2) => {
  SortTableLabels2[SortTableLabels2["sortPriority"] = 0] = "sortPriority";
  return SortTableLabels2;
})(SortTableLabels || {});
var BasicFieldLabels = /* @__PURE__ */ ((BasicFieldLabels2) => {
  BasicFieldLabels2[BasicFieldLabels2["showLogo"] = 0] = "showLogo";
  BasicFieldLabels2[BasicFieldLabels2["showItemUnitPrice"] = 1] = "showItemUnitPrice";
  BasicFieldLabels2[BasicFieldLabels2["fontWeight"] = 2] = "fontWeight";
  BasicFieldLabels2[BasicFieldLabels2["fontSize"] = 3] = "fontSize";
  BasicFieldLabels2[BasicFieldLabels2["elementSpacing"] = 4] = "elementSpacing";
  BasicFieldLabels2[BasicFieldLabels2["showTaxesIndividually"] = 5] = "showTaxesIndividually";
  BasicFieldLabels2[BasicFieldLabels2["printOrderQr"] = 6] = "printOrderQr";
  BasicFieldLabels2[BasicFieldLabels2["displayDefaultModifiers"] = 7] = "displayDefaultModifiers";
  BasicFieldLabels2[BasicFieldLabels2["addSubForMultiSelectOff"] = 8] = "addSubForMultiSelectOff";
  BasicFieldLabels2[BasicFieldLabels2["groupSameModItems"] = 9] = "groupSameModItems";
  BasicFieldLabels2[BasicFieldLabels2["printPriceForFreeModItems"] = 10] = "printPriceForFreeModItems";
  BasicFieldLabels2[BasicFieldLabels2["noForDeselectedDefaultModifiers"] = 11] = "noForDeselectedDefaultModifiers";
  BasicFieldLabels2[BasicFieldLabels2["onlyPrintModItemsWithPrice"] = 12] = "onlyPrintModItemsWithPrice";
  BasicFieldLabels2[BasicFieldLabels2["hideModGroupTitles"] = 13] = "hideModGroupTitles";
  BasicFieldLabels2[BasicFieldLabels2["modifierItemDisplayMode"] = 14] = "modifierItemDisplayMode";
  BasicFieldLabels2[BasicFieldLabels2["showFooterDescription"] = 15] = "showFooterDescription";
  BasicFieldLabels2[BasicFieldLabels2["footerDescription"] = 16] = "footerDescription";
  return BasicFieldLabels2;
})(BasicFieldLabels || {});
var AdvancedOptionsFieldLabels = /* @__PURE__ */ ((AdvancedOptionsFieldLabels2) => {
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["showTaxIndicator"] = 0] = "showTaxIndicator";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["taxIndicatorPosition"] = 1] = "taxIndicatorPosition";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["taxIndicatorColor"] = 2] = "taxIndicatorColor";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["taxIndicator"] = 3] = "taxIndicator";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["taxExemptIndicator"] = 4] = "taxExemptIndicator";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["customTypeNameDineIn"] = 5] = "customTypeNameDineIn";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["customTypeNameCurbside"] = 6] = "customTypeNameCurbside";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["customTypeNameToGo"] = 7] = "customTypeNameToGo";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["customTypeNameDelivery"] = 8] = "customTypeNameDelivery";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["customTypeNamePickup"] = 9] = "customTypeNamePickup";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["sortItemsBy"] = 10] = "sortItemsBy";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["secondSortItemsBy"] = 11] = "secondSortItemsBy";
  return AdvancedOptionsFieldLabels2;
})(AdvancedOptionsFieldLabels || {});
var returnLabel = (field) => {
  if (field in BasicFieldLabels || field in AdvancedOptionsFieldLabels) {
    return i18n_config_default.t(
      `app.modals.kitchenTicketDiffModal.ticketDisplay.${field}`
    );
  }
  if (field in CustomizingReceiptsFieldLabels) {
    return field;
  }
  if (field in CustomizingReceiptsValueIdFieldLabels) {
    return i18n_config_default.t(
      `settingsModule.kitchenTicketSettings.customizingReceiptsTable.value.options.${field}`
    );
  }
  if (field in SortTableLabels) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.general.modifierTags.${field}`
    );
  }
  return field;
};
var diffGuestCheckFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const basicChanges = generateBasicChangesArray(diffArray);
    const customizingReceipts = generateGuestCheckCustomizingReceiptsObj(diffArray);
    const courseChanges = generateGuestCheckCourseOrderArray(diffArray, state);
    const advancedChanges = generateAdvancedChangesArray(diffArray);
    return {
      basicChanges,
      customizingReceipts,
      courseChanges,
      advancedChanges
    };
  }
  return null;
};
var generateBasicChangesArray = (diffArray) => {
  const ticketDisplay = getDiffArray(
    diffArray,
    returnLabel,
    BasicFieldLabels,
    1
  );
  return ticketDisplay.map((diff) => {
    const { field, value } = diff;
    if (field === "modifierItemDisplayMode") {
      return __spreadProps(__spreadValues({}, diff), {
        textValue: i18n_config_default.t(
          `settingsModule.registerTicketSettings.ticketDisplay.modifiersDisplay.modifierItemDisplayMode.options.${value}`
        )
      });
    } else if (field === "fontSize") {
      return __spreadProps(__spreadValues({}, diff), {
        textValue: i18n_config_default.t(
          `settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontSize.options.${value}`
        )
      });
    } else if (field === "taxIndicatorPosition") {
      return __spreadProps(__spreadValues({}, diff), {
        textValue: i18n_config_default.t(
          `commonTexts.${diff.value.toString().toLowerCase()}`
        )
      });
    } else if (field === "taxIndicatorColor") {
      return __spreadProps(__spreadValues({}, diff), {
        textValue: i18n_config_default.t(
          `settingsModule.kitchenTicketSettings.printerColors.${diff.value}`
        )
      });
    } else if (field === "elementSpacing") {
      return __spreadProps(__spreadValues({}, diff), {
        textValue: `${diff.value}"`
      });
    } else if (field === "fontWeight") {
      return __spreadProps(__spreadValues({}, diff), {
        textValue: i18n_config_default.t(
          `settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontWeight.options.${diff.value}`
        )
      });
    } else if (field === "tipOptionOne" || field === "tipOptionTwo" || field === "tipOptionThree") {
      return __spreadProps(__spreadValues({}, diff), {
        textValue: `${diff.value}%`
      });
    }
    return diff;
  });
};
var generateAdvancedChangesArray = (diffArray) => {
  const advancedOptions = getDiffArray(
    diffArray,
    returnLabel,
    AdvancedOptionsFieldLabels,
    1
  );
  return advancedOptions.map((diff) => {
    const { field, value } = diff;
    if (field === "sortItemsBy") {
      return __spreadProps(__spreadValues({}, diff), {
        textValue: i18n_config_default.t(
          `settingsModule.guestCheckSettings.sortItemsBy.options.${value}`
        )
      });
    } else if (field === "secondSortItemsBy") {
      return __spreadProps(__spreadValues({}, diff), {
        textValue: i18n_config_default.t(
          `settingsModule.guestCheckSettings.secondSortItemsBy.options.${value}`
        )
      });
    }
    return diff;
  });
};
var generateGuestCheckCustomizingReceiptsObj = (diffArray) => {
  const ticketHeader = [];
  const ticketFooter = [];
  const TICKET_HEADER_FIELD = "ticketHeader";
  const TICKET_FOOTER_FIELD = "ticketFooter";
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength }) => {
        if (diffLength !== 3) {
          return;
        }
        const tableField = diff.path[0];
        const id = diff.path[1];
        if (diff.kind === "E") {
          const customNewDiff = {
            field,
            label: returnLabel(field) || "",
            value: diff.rhs
          };
          if (tableField === TICKET_HEADER_FIELD) {
            if (!ticketHeader.find((row) => row.id === id)) {
              ticketHeader.push({
                id,
                label: returnLabel(id) || "",
                changes: [customNewDiff]
              });
            } else {
              for (const [i, row] of ticketHeader.entries()) {
                if (row.id === id) {
                  ticketHeader[i].changes = [...row.changes, customNewDiff];
                  break;
                }
              }
            }
          } else if (tableField === TICKET_FOOTER_FIELD) {
            if (!ticketFooter.find((row) => row.id === id)) {
              ticketFooter.push({
                id,
                label: returnLabel(id) || "",
                changes: [customNewDiff]
              });
            } else {
              for (const [i, row] of ticketFooter.entries()) {
                if (row.id === id) {
                  ticketFooter[i].changes = [...row.changes, customNewDiff];
                  break;
                }
              }
            }
          }
        }
      },
      returnLabel
    )
  );
  return {
    ticketHeader,
    ticketFooter
  };
};
var generateGuestCheckCourseOrderArray = (diffArray, state) => {
  const courses = selectLocationCourses(state);
  const changeData = selectCurrentSettingsData(state);
  const courseOrders = [];
  const COURSE_ORDER_FIELD = "courseOrder";
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        const customField = diff.path[0];
        if (diffLength >= 2 && customField === COURSE_ORDER_FIELD) {
          if (diff.kind === "E") {
            const index = Number(diff.path[1]);
            const id = changeData.courseOrder[index].courseId;
            if (!(field in SortTableLabels)) {
              return;
            }
            if (!courseOrders.find((orderSeatTag) => orderSeatTag.id === id)) {
              courseOrders.push({
                id,
                label: courses[id].name,
                changes: [newDiff],
                index
              });
            } else {
              for (const [i, orderSeatTag] of courseOrders.entries()) {
                if (orderSeatTag.id === id) {
                  courseOrders[i].changes = [...orderSeatTag.changes, newDiff];
                  break;
                }
              }
            }
          }
        }
      },
      returnLabel
    )
  );
  return courseOrders;
};

export { diffGuestCheckFactory, generateGuestCheckCourseOrderArray, generateGuestCheckCustomizingReceiptsObj };
